<script setup lang="ts">
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  url: string | null;
  size?: string;
  alt?: string;
  shouldFill?: boolean;
}

withDefaults(defineProps<Props>(), { size: undefined, alt: undefined });
</script>

<template>
  <img
    v-if="url"
    class="image"
    :class="classNames({ shouldFill })"
    :style="{ width: size, height: size }"
    :src="url"
    :alt="alt"
  />
</template>

<style lang="scss" scoped>
@use './Image.scss';
</style>
